import React from 'react';
import Card from '../components/card';
import { InfoCopy, InfoLink } from '../components/info-link';
import { DollarTextField } from '../components/MaskedTextField';
import RadioButtons from '../components/RadioButtons';
import style from '../styles/form';
import { LoanCard } from './card-lenses';

const titles = (scenario) => {
  switch (scenario) {
    case 'Preapproval':
      return 'are you looking for';
    case 'RefiFull':
    case 'RefiQualify':
      return 'are you refinancing';
    default:
      return 'are you purchasing';
  }
};

const Info = (props) => (
  <InfoLink title="Property Types" {...props}>
    <h6>Single Family</h6>
    <InfoCopy>
      A mortgage loan secured by a property that contains one residential dwelling unit.
    </InfoCopy>
    <h6>Condominium (condo)</h6>
    <InfoCopy>
      A unit in a condominium project. Each unit owner has title to his or her individual unit, an
      individual interest in the project’s common areas, and, in some cases, the exclusive use of
      certain limited common areas.
    </InfoCopy>
    <h6>Multi-Family</h6>
    <InfoCopy>
      Properties that provide separate housing units for two or more families, although they secure
      only a single mortgage.
    </InfoCopy>
    <h6>Townhouse</h6>
    <InfoCopy>
      A property type typically constructed with common walls bordering the adjacent units. The
      property owner not only owns his or her unit, but also an undivided interest in any common
      area. In some cases, a townhouse owner owns the physical structure rather than just the space
      inside the walls, like a condo owner. In some cases, However, &quot;townhouse&quot; can simply
      be a term to reference the style of the structure rather than the form of ownership.
    </InfoCopy>
    <h6>Manufactured Home</h6>
    <InfoCopy>
      A property that is assembled in a factory, transported to the site of use, and attached to a
      permanent foundation system.
    </InfoCopy>
    <h6>Mobile Home</h6>
    <InfoCopy>
      A large trailer or transportable prefabricated structure that is situated in one particular
      place, used as a permanent living accommodation, but is not attached to a permanent foundation
      system.
    </InfoCopy>
  </InfoLink>
);

const PropertyType = ({ model, onChange, ...cardProps }) => (
  <Card
    title={`What type of property ${titles(model.get('scenario'))}?`}
    info={Info}
    {...cardProps}
  >
    <RadioButtons
      name="propertyType"
      value={model.get('propertyType')}
      onChange={onChange.bind(null, 'propertyType')}
      choices={[
        {
          value: 'SingleFamily',
          label: 'Single Family'
        },
        {
          value: 'Condo',
          label: 'Condo'
        },
        {
          value: 'MultiFamily',
          label: 'Multi-Family'
        },
        {
          value: 'Townhome',
          label: 'Townhome'
        },
        {
          value: 'Manufactured',
          label: 'Manufactured Home'
        },
        {
          value: 'Mobile',
          label: 'Mobile Home'
        }
      ]}
    />
    {model.get('propertyType') === 'Condo' && model.get('scenario') !== 'Preapproval' ? (
      <DollarTextField
        name="condoFee"
        value={model.get('condoFee')}
        onChange={onChange.bind(null, 'condoFee')}
        style={style.threeQuarters}
        floatingLabelText="Monthly Condo Fee"
      />
    ) : model.get('propertyType') === 'Townhome' && model.get('scenario') !== 'Preapproval' ? (
      <DollarTextField
        name="hoaFee"
        value={model.get('condoFee')}
        onChange={onChange.bind(null, 'condoFee')}
        style={style.threeQuarters}
        floatingLabelText="Monthly homeowners association fee"
      />
    ) : null}
  </Card>
);

PropertyType.completed = ({ model }) =>
  ['SingleFamily', 'Condo', 'MultiFamily', 'Townhome', 'Manufactured', 'Mobile'].includes(
    model.get('propertyType')
  ) &&
  ((model.get('propertyType') === 'Condo' || model.get('propertyType') === 'Townhome') &&
  model.get('scenario') !== 'Preapproval'
    ? model.get('condoFee') != null
    : true);

PropertyType.id = 'PropertyType';

export default LoanCard(PropertyType);



// WEBPACK FOOTER //
// ./src/cards/property-type.js